import React from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";

const TermsAndConditions = () => {
  return (
    <div className="main-wrapper">
      <div className="text-center mt-4">
        <ImageWithBasePath
          src="assets/images/logo.png"
          alt="iKidz"
           width={150}
          // height={200}
          className="img-fluid"
        />
      </div>

      <div className="container my-4">
        <div className="card shadow-sm">
          <div className="card-body p-4">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
              <h3 className="mb-0">Terms &amp; Conditions</h3>
              <Link to={all_routes.login} className="btn btn-outline-primary btn-sm">
                Back to Login
              </Link>
            </div>

            <p className="text-muted">
              By using iKidz, you agree to the terms below. If you do not agree,
              please do not use the service.
            </p>

            <h6 className="mt-4">Use of the service</h6>
            <ul className="text-muted">
              <li>Use the platform only for lawful purposes.</li>
              <li>Keep your login credentials secure.</li>
              <li>Do not attempt to disrupt or misuse the platform.</li>
            </ul>

            <h6 className="mt-4">Accounts and access</h6>
            <p className="text-muted">
              We may suspend or terminate access if we reasonably believe the
              service is being used in violation of these terms.
            </p>

            <h6 className="mt-4">Limitation of liability</h6>
            <p className="text-muted mb-0">
              The service is provided “as is”. To the maximum extent permitted by
              law, iKidz is not liable for indirect or consequential damages.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;

